import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class ProcessSchedulerService {

  constructor(private http: HttpClient) { }

  get_importtimesheet_scheduler() {
    return this.http.get<any>(Library.API_ENDPOINT + 'process/get_importtimesheet_scheduler', OPTIONS);
  }

  getSchedules() {
    return this.http.get<any>(Library.API_ENDPOINT + 'process/get_scheduler_schedules', OPTIONS);
  }

  insert_time_entries_process(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'process/insert_time_entries_process', processForm, OPTIONS);
  }

  get_timesheet_scheduler() {
    return this.http.get<any>(Library.API_ENDPOINT + 'process/get_timesheet_scheduler', OPTIONS);
  }

  insert_timesheet_process(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'process/insert_timesheet_process', processForm, OPTIONS);
  }

  insert_timesheet_process_immediate(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'process/insert_timesheet_process_immediate', processForm, OPTIONS);
  }

  generate_employe_fixed_timesheet(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'process/generate_employe_fixed_timesheet', processForm, OPTIONS);
  }

  insert_import_timesheet_process_immediate(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'process/insert_import_timesheet_process_immediate', processForm, OPTIONS);
  }

  insert_batch_timesheet_process_immediate(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'process/insert_batch_timesheet_process_immediate', processForm, OPTIONS);
  }

  get_payroll_process() {
    return this.http.get<any>(Library.API_ENDPOINT + 'process/get_payroll_process', OPTIONS);
  }

  insert_payroll_process(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'process/insert_payroll_process', processForm, OPTIONS);
  }

  process_payroll_invoice(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'process/process_payroll_invoice', processForm, OPTIONS);
  }

  get_payroll_invoice_process() {
    return this.http.get<any>(Library.API_ENDPOINT + 'process/get_payroll_invoice_process', OPTIONS);
  }

  getPayrollProcesses() {
    return this.http.get<any>(Library.API_ENDPOINT + 'process/get_payroll_processes', OPTIONS);
  }

  getComputations() {
    return this.http.get<any>(Library.API_ENDPOINT + 'process/get_period_computation', OPTIONS);
  }

  insert_payroll_invoice(processForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'process/insert_payroll_invoice', processForm, OPTIONS);
  }

  delete_process(process: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'process/delete_process_scheduler', process, OPTIONS);
  }
}
